import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {  ShowMessageDialogComponent} from '../components/show-message-dialog/show-message-dialog.component';
import { DeleteConfirmationDialog } from '../components/delete-confirmation/delete-confirmation.dialog';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog) { }

  showMessage(title: string, message: string) {
    const dialogRef = this.dialog.open(ShowMessageDialogComponent, {
      width: '300px',
      data: {
        title,
        message
      }
    });
  }

  showMessageWithCallback(title: string, message: string, collback: () => any) {
    const dialogRef = this.dialog.open(ShowMessageDialogComponent, {
      width: '300px',
      data: {
        title,
        message
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      collback();
    });
  }

  showConfirmDialog(dialogTitle: string, dialogMessage: string): Observable<any> {
    const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
      width: '300px',
      data: {
        title: dialogTitle,
        message: dialogMessage,
        key: '',
        enterKeyToConfirm: false
      }
    });

    return dialogRef.afterClosed();
  }
}
